import notificationError from '@/utils/functions/notificationError';
import { useMutation, useQuery } from 'react-query';
import reportTemplatesServices from './ReportTemplates.services';
import { ReportTemplatesWorkorderRequest } from './ReportTemplates.types';
import { notification } from 'antd';

export function useReportTemplateGenerateWorkorder({
  enabled,
  ...params
}: ReportTemplatesWorkorderRequest & { enabled: boolean }) {
  return useQuery(
    ['report/template/workorder', params],
    () => reportTemplatesServices.generateWorkorder(params),
    {
      enabled: !!params.companyId && !!params.format && !!enabled,
      onError(error) {
        notificationError(error);
      },
    },
  );
}

export function useReportTemplateGenerateReceipt() {
  return useMutation(reportTemplatesServices.generateReceipt, {
    onSuccess() {
      notification.success({
        message: 'Recibo gerado com sucesso!',
        description: 'Recibo de lançamento bancário gerado com sucesso.',
      });
    },
    onError(error) {
      notificationError(error);
    },
  });
}
